import { siteConfig } from '@/config/site';
import './LogoWatermark.css';

/**
 * Casa de Candy — global diagonal logo watermark.
 *
 * Renders a fixed, full-viewport SVG-based pattern of the brand mark tiled
 * diagonally across the page. Each tile is large (≈ 600px) and the layer
 * sits behind every page section via `pointer-events:none` + a low z-index.
 *
 * A soft dark gradient is layered on top of the watermark so legal copy
 * stays effortlessly readable.
 *
 * The watermark animates with a slow drift to add subtle premium movement.
 */
export function LogoWatermark({ intensity = 'default' }) {
  return (
    <div
      className={`logo-watermark logo-watermark--${intensity}`}
      aria-hidden
      data-testid="logo-watermark"
    >
      <div
        className="logo-watermark__pattern"
        style={{ backgroundImage: `url('${siteConfig.brand.logoUrl}')` }}
      />
      <div className="logo-watermark__veil" />
    </div>
  );
}

export default LogoWatermark;
